import { TextField as MUITextField, Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import EducationSection from "components/request-document/components/EducationSection";
import PersonalInfoSection from "components/request-document/components/PersonalInfoSection";
import SpouseSection from "components/request-document/components/SpouseSection";
import useSmartSubName from "components/request-document/hooks/useSmartSubName";
import { useFormik } from "formik";
import nationalities from "i18n-nationality";
import {
  REQUEST_DOCUMENT_STEP,
  RoleId,
  STATUS_PROCESS
} from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import {
  defaultChildren,
  defaultEducationData,
  defaultSpouse,
  getDefaultRow,
  getErrorMessage,
  isError,
  mapChildren,
  mapEducationData,
  mapSpouse,
  personalFieldResolver
} from "libs/utils/form";
import { formatDate } from "libs/utils/format";
import { convertMRZDate } from "libs/utils/mrzUtils";
import { get, pick } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addPersonal,
  addPersonalSlice,
  selectAddPersonal
} from "redux/modules/addPersonalSlice";
import { canEditForm } from "redux/modules/authSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { selectPassportState } from "redux/modules/passportSlice";
import { getPersonalDetail, selectPersonalDetail } from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  getSmartForm,
  getSmartFormFieldConfig,
  selectAddSmartForm,
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectDraftId,
  selectSmartFormFieldConfig
} from "redux/modules/visaForm";
import * as yup from "yup";

const TextField = React.memo(MUITextField);

export default function UserProfileStep() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const subName = useSmartSubName();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const passportState = useSelector(selectPassportState);
  const personalDetail = useSelector(selectPersonalDetail);
  const addPersonalState = useSelector(selectAddPersonal);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const masterData = useSelector(selectMasterData);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const draftId = useSelector(selectDraftId);
  const smartform = useSelector(selectCurrentSmartForm);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const canEdit = useSelector(canEditForm);
  const assignmentConfig = get(masterData, "assignmentConfig", []);
  const Role = useSelector((e) => {
    return e.user.profile.roleId;
  });

  const nationalityConfig = get(masterData, "nationalityConfig", []);
  const personalId = get(personalDetail, "personalID", "");
  const ocrFirstName = get(passportState, "detail.firstName", "");
  const ocrLastName = get(passportState, "detail.lastName", "");
  const ocrBirthDate = convertMRZDate(
    get(passportState, "detail.birthDate", "")
  );
  const nationalityAlpha3 = get(passportState, "detail.nationality", "");
  const nationalityName = nationalities.getName(nationalityAlpha3, "en");
  const ocrNationalityID = get(
    nationalityConfig.find((v) => v.nationalityName === nationalityName),
    "nationalityID",
    ""
  );
  const ocrExpirationDate = convertMRZDate(
    get(passportState, "detail.expirationDate", "")
  );
  const ocrSex = get(passportState, "detail.sex", "").slice(0, 1).toUpperCase();
  const ocrDocumentNumber = get(passportState, "detail.documentNumber", "");

  const personal = pick(get(smartform, "personal", {}), [
    "personalID",
    "firstname",
    "middleName",
    "lastName",
    "nationalityID",
    "birthDate",
    "email",
    "placeOfBirth",
    "gender",
    "passportNumber",
    "dateofIssue",
    "validuntil",
    "visatypeID",
  ]);
  const detailList = [
    "Marittal",
    "AddressInHome",
    "AddressInThai",
    "SubDistrict",
    "District",
    "Province",
    "Zipcode",
    "PhoneNumber",
    "Email",
    "assignmentId",
    "assignmentId2",
    "assignmentId3",
    "DetailofExpertise",
    "Spouse",
    "Children",
    "EducationOther",
    "EducationId",
  ];
  const detail = get(smartform, "detail", [])
    .filter((field) => detailList.includes(field.smartName))
    .reduce((p, c) => ({ ...p, [c.smartName]: c }), {});

  useEffect(() => {
    dispatch(
      getMasterData({
        nationalityConfig: true,
        AssignmentConfig: true,
        EducationConfig: true,
        CountryConfig: true,
      })
    );
    return () => {
      dispatch(addPersonalSlice.actions.clearAsyncState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalDetail, personalId, smartServiceId]);

  useEffect(() => {
    if (!addPersonalState.isLoading) {
      if (addPersonalState.isSuccess) {
        dispatch(addPersonalSlice.actions.clearAsyncState());
      } else if (addPersonalState.isFailure) {
        hideLoading();
        alert(addPersonalState.error?.message);
        dispatch(addPersonalSlice.actions.clearAsyncState());
      }
    }
  }, [addPersonalState, dispatch, hideLoading]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.PART_A_2));
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [addSmartFormState, dispatch, hideLoading, isSaveDraft]);

  const validationSchema = yup.object({});

  const callAPISubmit = async (values) => {
    showLoading();

    const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
    const documentFields = Object.keys(values.document);
    const getFieldListConfig = defaultType.filter((field) =>
      documentFields.includes(field.smartName)
    );

    const getValue = (field) => {
      switch (field.smartName) {
        case "Spouse": {
          const spouseName = get(values, `document.${field.smartName}`, []);
          const value = spouseName.filter((v) => !!v.SpouseName);
          return value || null;
        }
        case "Children": {
          const childrenName = get(values, `document.${field.smartName}`, []);
          const value = childrenName.filter((v) => !!v.ChildrenName);
          return value || null;
        }
        case "EducationId": {
          const educationId = get(values, `document.${field.smartName}`, {
            EducationConfigID: null,
            data: [],
          });
          const data = educationId.data.filter((v) => !!v.educationName);
          return {
            EducationConfigID: educationId.EducationConfigID,
            data: data.length ? data : null,
          };
        }
        default:
          return get(values, `document.${field.smartName}`, null);
      }
    };

    const getSmartId = (field) =>
      get(detail, `${field.smartName}.smartId`, null);

    const prepareData = {
      draftId: draftId || null,
      smartserviceId: smartServiceId,
      personalId: personalId,
      survey: null, // get(smartform, "survey", null), // TODO wait for support case edit
      visaissuance: null, // get(smartform, "visaissuance", null), // TODO wait for support case edit
      detail: [
        ...getFieldListConfig.map((field) => ({
          smartName: field.smartName,
          smartId: getSmartId(field),
          partfromId: field.partfromId,
          configsmartId: field.configsmartId,
          linkTable: field.linkTable,
          value: getValue(field),
        })),
      ],
    };

    await dispatch(
      addPersonal({
        ...personalFieldResolver(values.personal),
        visatypeID: null,
      })
    );
    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };

  const HasAddressInThai = !!get(detail, "AddressInThai.value", "");
  const isDraftDocument = smartform?.statausID === STATUS_PROCESS.Draft;

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      personal: {
        personalID: get(personal, "personalID", ""),
        fistName: ocrFirstName || get(personal, "firstname", ""),
        middleName: get(personal, "middleName", "") || "",
        lastName: ocrLastName || get(personal, "lastName", ""),
        nationalityID:
          ocrNationalityID || get(personal, "nationalityID", "") || "",
        birthDate: formatDate(
          ocrBirthDate || get(personal, "birthDate", "") || ""
        ),
        email: get(personal, "email", "") || "",
        placeOfBirth: get(personal, "placeOfBirth", "") || "",
        gender: ocrSex || get(personal, "gender", "M") || "M",
        passportNumber:
          ocrDocumentNumber || get(personal, "passportNumber", "") || "",
        dateofIssue: formatDate(get(personal, "dateofIssue", "") || ""),
        validuntil: formatDate(
          ocrExpirationDate || get(personal, "validuntil", "") || ""
        ),
        visatypeID: null,
      },
      document: {
        Marittal: get(detail, "Marittal.value", "S"),
        AddressInHome: get(detail, "AddressInHome.value", ""),
        HasAddressInThai,
        AddressInThai: get(detail, "AddressInThai.value", ""),
        SubDistrict: get(detail, "SubDistrict.value", ""),
        District: get(detail, "District.value", ""),
        Province: get(detail, "Province.value", ""),
        Zipcode: get(detail, "Zipcode.value", ""),
        PhoneNumber: get(detail, "PhoneNumber.value", ""),
        Email: get(detail, "Email.value", ""),
        assignmentId: get(detail, "assignmentId.value", ""),
        assignmentId2: get(detail, "assignmentId2.value", ""),
        assignmentId3: get(detail, "assignmentId.3value", ""),
        DetailofExpertise: get(detail, "DetailofExpertise.value", ""),
        Spouse: getDefaultRow(detail, "Spouse.value", defaultSpouse).map(
          mapSpouse
        ),
        Children: getDefaultRow(detail, "Children.value", defaultChildren).map(
          mapChildren
        ),
        EducationOther: get(detail, "EducationOther.value", ""),
        EducationId: {
          EducationConfigID: null,
          data: getDefaultRow(
            detail,
            "EducationId.value.data",
            defaultEducationData
          ).map(mapEducationData),
        },
      },
    },
    validationSchema: isDraftDocument ? validationSchema : yup.object({}),
    onSubmit: async (values) => {
      if (!canEdit) {
        dispatch(setSmartFormStep(SMART_T_STEP.PART_A_2));
        return;
      }
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  useEffect(() => {

    const firstTimeSavePersonal = async () => {
      await dispatch(
        addPersonal({
          ...personalFieldResolver(formik.values.personal),
          visatypeID: null,
        })
      );
      await dispatch(getPersonalDetail({ personalId }))
    }

    if (
      nationalityConfig.length &&
      ocrDocumentNumber && ocrDocumentNumber !== get(personal, "passportNumber", "")) {
      firstTimeSavePersonal()
    }
    
  }, [nationalityConfig, ocrDocumentNumber])

  // Disabled all field if status != draft
  if (!isDraftDocument && Role !== RoleId.Admin) {
    formik.handleBlur = () => {};
    formik.handleChange = () => {};
    formik.setFieldValue = () => {};
  }

  return (
    <div className={classes.root}>
      <ContentTitle
        title="Application Form"
        subTitle={`APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “T” ${subName}`}
      />
      <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} />
      <form onSubmit={formik.handleSubmit} disabled>
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={7}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part A : Personal Information
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <PersonalInfoSection formik={formik} />
              <SpouseSection
                defaultChildren={mapChildren(defaultChildren)}
                formik={formik}
              />
              <EducationSection
                defaultEducationData={mapEducationData(defaultEducationData)}
                formik={formik}
              />

              <TableRow>
                <StyledTableCell colSpan={7}>
                  <div className={classes.cellContent}>
                    <Bagde number={17} />
                    <div>
                      <Typography>
                        Please select your area of expertise which will be
                        employed during your work assignment in Thailand. You
                        can select more than one area of expertise.
                      </Typography>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell
                  colSpan={7}
                  style={{
                    padding: 0,
                    margin: 0,
                    border: 0,
                    borderLeft: 0,
                    borderBottom: 0,
                    width: "100%",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <StyledTableCell style={{ width: "100%", padding: 4 }}>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            error={isError("document.assignmentId", formik)}
                          >
                            <InputLabel>Select area of expertise</InputLabel>
                            <Select
                              label="Select area of expertise"
                              name="document.assignmentId"
                              value={formik.values.document.assignmentId}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              style={{ width: "100%" }}
                              displayEmpty
                              disabled={!canEdit}
                            >
                              {assignmentConfig.map((assignment) => (
                                <MenuItem
                                  value={assignment.assignmentId}
                                  key={assignment.assignmentId}
                                >
                                  {assignment.assignmentName}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText
                              error={isError("document.assignmentId", formik)}
                            >
                              {getErrorMessage("document.assignmentId", formik)}
                            </FormHelperText>
                          </FormControl>
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell style={{ width: "100%", padding: 4 }}>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            error={isError("document.assignmentId", formik)}
                          >
                            <InputLabel>
                              Select 2nd area of expertise
                            </InputLabel>
                            <Select
                              label="Select 2nd area of expertise"
                              name="document.assignmentId2"
                              value={formik.values.document.assignmentId2}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              style={{ width: 280 }}
                              disabled={!canEdit}
                            >
                              {assignmentConfig.map((assignment) => (
                                <MenuItem
                                  value={assignment.assignmentId}
                                  key={assignment.assignmentId}
                                >
                                  {assignment.assignmentName}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText
                              error={isError("document.assignmentId2", formik)}
                            >
                              {getErrorMessage(
                                "document.assignmentId2",
                                formik
                              )}
                            </FormHelperText>
                          </FormControl>
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell style={{ width: "100%", padding: 4 }}>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            error={isError("document.assignmentId", formik)}
                          >
                            <InputLabel>
                              Select 3nd area of expertise
                            </InputLabel>
                            <Select
                              label="Select 3nd area of expertise"
                              name="document.assignmentId3"
                              value={formik.values.document.assignmentId3}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              style={{ width: 280 }}
                              disabled={!canEdit}
                            >
                              {assignmentConfig.map((assignment) => (
                                <MenuItem
                                  value={assignment.assignmentId}
                                  key={assignment.assignmentId}
                                >
                                  {assignment.assignmentName}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText
                              error={isError("document.assignmentId3", formik)}
                            >
                              {getErrorMessage(
                                "document.assignmentId3",
                                formik
                              )}
                            </FormHelperText>
                          </FormControl>
                        </div>
                      </div>
                    </StyledTableCell>
                  </div>
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell colSpan={7}>
                  <div className={classes.cellContent}>
                    <Bagde number={18} />
                    <div className={classes.wrapField}>
                      <InputLabel>
                        Details of expertise to be recognized (Please provide
                        details related to all technologies selected in no.17
                        only)
                      </InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="document.DetailofExpertise"
                        multiline
                        rows={5}
                        rowsMin={5}
                        rowsMax={5}
                        value={formik.values.document.DetailofExpertise}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.DetailofExpertise", formik)}
                        helperText={getErrorMessage(
                          "document.DetailofExpertise",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <ButtonController
          onClickSaveDraft={() => {
            setSaveDraft(true);
            callAPISubmit(formik.values);
          }}
        />
      </form>
    </div>
  );
}
